import type MP4Box from 'mp4box';
import { TrackEventProp } from '@studio/constants/tracking-constants';
import type { VideoUploadTrackEventProperties } from '../../types/upload-video';

const logTimescale = (info: MP4Box.Mp4BoxInfo, trackEventProperties: VideoUploadTrackEventProperties): void => {
  if (info.videoTracks.length) {
    const [videoTrack] = info.videoTracks;
    const { timescale } = videoTrack;
    console.log(`Timescale: ${timescale}`);

    trackEventProperties[TrackEventProp.VIDEO_UPLOAD_TIMESCALE] = timescale;
  }
};

export default logTimescale;
